// 🔐 CSRF token injection for HTMX
document.body.addEventListener("htmx:configRequest", function (event) {
    const tokenInput = document.querySelector("input[name='__RequestVerificationToken']");
    if (tokenInput) {
        event.detail.headers['RequestVerificationToken'] = tokenInput.value;
    }
});

// 🎯 Turnstile initialization helper
function initTurnstile() {
    const box = document.getElementById('turnstile-box');
    if (!box) return;

    if (box.childNodes.length === 0) {
        if (typeof turnstile !== 'undefined') {
            turnstile.render(box, {
                sitekey: box.dataset.sitekey
            });
        } else {
            console.warn('Turnstile script not loaded yet');
        }
    }
}

// 🎯 Initialize Turnstile on page load (after script loads)
window.addEventListener('load', function() {
    if (typeof turnstile !== 'undefined') {
        initTurnstile();
    } else {
        // Fallback: wait up to 5s for Turnstile to load
        let attempts = 0;
        const checkTurnstile = setInterval(function() {
            if (typeof turnstile !== 'undefined') {
                clearInterval(checkTurnstile);
                initTurnstile();
            } else if (++attempts >= 50) {
                clearInterval(checkTurnstile);
                console.error('Turnstile failed to load after 5 seconds');
            }
        }, 100);
    }
});

// 🧹 Form interaction handler (HTMX afterSwap + Clear button)
function setupFormHandlers() {
    const wrapper = document.getElementById('user-form-wrapper');
    if (!wrapper) return;

    wrapper.style.transition = 'opacity 200ms ease-in-out';
    wrapper.style.opacity = 1;

    const errorBanner = wrapper.querySelector(".form-error-banner");
    if (errorBanner) {
        errorBanner.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    initTurnstile();

    const form = document.getElementById("contact-form");

    const clearBtn = form?.querySelector('button[type="reset"]');
    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            form.querySelectorAll(".field-validation-error, .input-validation-error").forEach(el => {
                el.classList.remove("field-validation-error", "input-validation-error");
                if (el.tagName === "SPAN" || el.tagName === "DIV") el.textContent = "";
            });

            const banner = form.querySelector(".form-error-banner");
            if (banner) banner.remove();

            const recaptchaError = form.querySelector(".recaptcha-error");
            if (recaptchaError) recaptchaError.remove();

            if (typeof turnstile !== 'undefined') {
                turnstile.reset();
            }
        });
    }

    history.replaceState(null, "", "#contact");
}

// 🧹 Remove Turnstile widget before HTMX replaces the DOM (avoids "cannot find widget" warning). Only when the section
// really is about to be replaced: an error htmx will not swap left the form in place without its widget, and a refused
// post's message goes into #contact-form-result (the form's data-refusal-target, htmx-refusals.js), not the section.
document.body.addEventListener('htmx:beforeSwap', function (e) {
    if (e.detail.shouldSwap && e.detail.target.id === 'contact-form-section') {
        if (typeof turnstile !== 'undefined') {
            const box = document.getElementById('turnstile-box');
            if (box) turnstile.remove(box);
        }
    }
});

// 🔄 Re-setup after HTMX swap (target is #contact-form-section)
document.body.addEventListener('htmx:afterSwap', function (e) {
    if (e.detail.target.id === 'contact-form-section') {
        setupFormHandlers();
        const section = document.getElementById('contact-form-section');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
});
